module.exports = __webpack_public_path__ + "img/product-index.59690894.jpg";